module.exports = __webpack_public_path__ + "static/media/pengeluaran.2b99b894.png";